import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSocketIO from "vue-socket.io";
import { VueMasonryPlugin } from "vue-masonry";
import VueTapTarget from "vue-tap-target";

Vue.use(VueTapTarget);

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: "https://trast.live"
  })
);

Vue.use(VueMasonryPlugin);

Vue.config.productionTip = false;

Vue.directive("blur", {
  inserted: function(el) {
    el.onfocus = ev => ev.target.blur();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
